import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ciwc-auth-layout',
  templateUrl: './auth-layout.component.html',
  imports: [RouterOutlet],
  styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent implements OnInit {
  ngOnInit(): void {
    console.log('AuthLayoutComponent.ngOnInit()');
  }
}
